import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import type { ClassValue } from "clsx";

/**
 * Merge Tailwind classes without conflicts.
 * Re-exported from each component so callers don't need to import separately.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
